// Mouse Stalker
export default class MouseStalker {
  constructor() {
    this.area = document.querySelector('.js-mouse-stalker-area')
    this.stalker = document.querySelector('.js-mouse-stalker')

    if (!this.area || !this.stalker) return

    this._rafId = null
    this._rafScheduled = false
    this._clientX = 0
    this._clientY = 0

    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseMove = this.handleMouseMove.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
    this.applyPosition = this.applyPosition.bind(this)

    this.init()
  }

  init() {
    this.area.addEventListener('mouseenter', this.handleMouseEnter)
    this.area.addEventListener('mousemove', this.handleMouseMove)
    this.area.addEventListener('mouseleave', this.handleMouseLeave)
  }

  handleMouseEnter() {
    this.stalker.classList.add('is-visible')
  }

  handleMouseMove(e) {
    this._clientX = e.clientX
    this._clientY = e.clientY

    if (!this._rafScheduled) {
      this._rafScheduled = true
      this._rafId = requestAnimationFrame(this.applyPosition)
    }
  }

  applyPosition() {
    this._rafScheduled = false
    this._rafId = null

    const rect = this.area.getBoundingClientRect()
    const x = this._clientX - rect.left
    const y = this._clientY - rect.top

    this.stalker.style.transform = `translate3d(${x}px, ${y}px, 0)`
  }

  handleMouseLeave() {
    if (this._rafId != null) {
      cancelAnimationFrame(this._rafId)
      this._rafId = null
    }
    this._rafScheduled = false

    this.stalker.classList.remove('is-visible')
  }
}
